<template>
  <div
    class="ds-text-base ds-text-ellipsis ds-whitespace-nowrap ds-overflow-hidden"
    :class="{
      'ds-text-primary': !selected,
      'ds-text-neutral-900': selected,
    }"
  >
    <slot />
    <span :class="{ 'ds-font-semibold': selected }">{{ label }}</span>
    <span
      v-if="typeof count === 'number' && count !== Number.POSITIVE_INFINITY"
      class="ds-text-neutral-900 ds-text-xs"
      :class="{ 'ds-font-semibold': selected }"
    >({{ count }})</span>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
  selected?: boolean;
  count?: number;
}>();
</script>
